import React from 'react';

interface AnalyticsIconProps {
  className?: string;
}

const AnalyticsIcon: React.FC<AnalyticsIconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
    >
      <path d="M14,10c0,1.019-.308,1.964-.832,2.754l-2.875-2.875c-.188-.188-.293-.442-.293-.707V5.101c2.282,.463,4,2.48,4,4.899Zm-6-.414V5.101c-2.55,.518-4.396,2.976-3.927,5.767,.325,1.934,1.82,3.543,3.729,3.992,1.47,.345,2.86,.033,3.952-.691l-3.169-3.169c-.375-.375-.586-.884-.586-1.414Zm11-4.586h-2c-.553,0-1,.448-1,1s.447,1,1,1h2c.553,0,1-.448,1-1s-.447-1-1-1Zm0,4h-2c-.553,0-1,.448-1,1s.447,1,1,1h2c.553,0,1-.448,1-1s-.447-1-1-1Zm0,4h-2c-.553,0-1,.448-1,1s.447,1,1,1h2c.553,0,1-.448,1-1s-.447-1-1-1Zm5-7V14c0,2.757-2.243,5-5,5h-6v2h4c.553,0,1,.448,1,1s-.447,1-1,1H7c-.553,0-1-.448-1-1s.447-1,1-1h4v-2H5c-2.757,0-5-2.243-5-5V6C0,3.243,2.243,1,5,1h14c2.757,0,5,2.243,5,5Zm-2,0c0-1.654-1.346-3-3-3H5c-1.654,0-3,1.346-3,3V14c0,1.654,1.346,3,3,3h14c1.654,0,3-1.346,3-3V6Z"/>
    </svg>
  );
};

export default AnalyticsIcon;
